import React from 'react'
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet'

import { IconMapMarker, IconAboutLeft, IconAboutRight } from '../svg/index'

const About = ({ t }) => {
    return (
        <div className="container-about-page">
            <Helmet>
                <title>{t('_pages._about.title')} | Interacty</title>
            </Helmet>

            <h1>{t('_pages._about.title')}</h1>
            <div className="svg-group">
                <IconAboutLeft />
                <IconMapMarker />
                <IconAboutRight />
            </div>
            <h2>{t('_pages._about.address')}</h2>
            <article className="mb">{t('_pages._about.text_1')}</article>
            <h2 className="sm-left">{t('_pages._about.our_mission')}</h2>
            <article>
                {t('_pages._about.text_2')}
                <div className="separator" />
                {t('_pages._about.text_3')}
                <div className="separator" />
                {t('_pages._about.text_4_1')} <Link to="/contacts">{t('_pages._about.text_4_2')}</Link>.
            </article>
        </div>
    )
}

export default withTranslation('translations')(About)
